// extracted by mini-css-extract-plugin
module.exports = {"giantMenuContainer":"BigPageMenu-module--giant-menu-container--MP2LX","item":"BigPageMenu-module--item--3lkuR"};